import React from 'react';
import { EditModalForm } from './form';
import { observer } from 'mobx-react-lite';
import { IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Icon, SimpleModal, ExpandedTooltip } from '@livable/saas-react-components';
export const EditModalModal = observer(_ref => {
  let data = _ref.data,
    callback = _ref.callback;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    title: t('Credential edit'),
    trigger: /*#__PURE__*/React.createElement(ExpandedTooltip, {
      type: "grey",
      title: t('Edit credential'),
      placement: "top"
    }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
      type: "edit"
    }))),
    noFooter: true
  }, /*#__PURE__*/React.createElement(EditModalForm, {
    data: data,
    callback: callback
  }));
});